module.exports = __webpack_public_path__ + "media/images/icon-offline@3x-56f68e60756d37f11bbd9cf2fc04bf78.png";